import setActiveFloor from './setActiveFloor';

export default {
	setActiveFloor,
};
